<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <data-table :headings="comboDiscountGroupsHeadings" :data="comboDiscountGroups" :hasActions="true"
                            :pagingDetails="pagingDetails"
                            :stateChanged="filterStateChanged"
                            @pagingUpdated="onPagingUpdated"
                            @actionClicked="onComboDiscountGroupActionClicked" @filterSearchClicked="onFilterSearchClicked">
                    <template #actionButton>
                        <div class="w-100">
                            <button class="btn btn-primary" @click="onAddComboDiscountGroupClick">Add Group</button>
                        </div>
                    </template>
                    <template #filter>
                        <div class="p-3">
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.searchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                           :componentId="'comboDiscountGroupFilterRadioButtons'"
                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                        </div>
                    </template>
                </data-table>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="comboDiscountGroupMarkAsActiveInactiveModal.heading"
                :modalId="comboDiscountGroupMarkAsActiveInactiveModal.modalId"
                :isSaving="comboDiscountGroupMarkAsActiveInactiveModal.isSaving"
                :showModal="comboDiscountGroupMarkAsActiveInactiveModal.showModal"
                :isActive="comboDiscountGroupMarkAsActiveInactiveModal.isActive"
                @closeClicked="comboDiscountGroupMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>

    <link-products-to-combo-discount-group-modal
            :heading="linkProductsToComboDiscountGroupModal.heading"
            :modalId="linkProductsToComboDiscountGroupModal.modalId"
            :showModal="linkProductsToComboDiscountGroupModal.showModal"
            :comboDiscountGroupId="linkProductsToComboDiscountGroupModal.comboDiscountGroupId"
            @closeClicked="onLinkProductsToComboDiscountGroupModalCloseClick"
            @saveButtonClicked="onLinkProductsToComboDiscountGroupSaveClick">
    </link-products-to-combo-discount-group-modal>
</div>